INTERFACE_TYPE_EXTENSION